import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import './LegalPages.css';

export default function Datenschutz() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setLanguage(user.language || 'de');
      } catch (e) {
        setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
      }
    } else {
      setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
    }
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
        >
          ← {language === 'de' ? 'Zurück' : 'Back'}
        </Button>
        <Button 
          variant="outline" 
          onClick={toggleLanguage}
          className="language-toggle"
        >
          {language === 'de' ? '🇬🇧 English' : '🇩🇪 Deutsch'}
        </Button>
      </div>

      <div className="legal-content">
        {language === 'de' ? (
          <>
            <h1>Datenschutzerklärung</h1>
            <p className="last-updated">Stand: {new Date().toLocaleDateString('de-DE')}</p>

            <section>
              <h2>1. Datenschutz auf einen Blick</h2>
              
              <h3>Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie unsere Website besuchen und unseren 
                Dienst nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich 
                identifiziert werden können.
              </p>

              <h3>Datenerfassung auf unserer Website</h3>
              <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>

              <p><strong>Wie erfassen wir Ihre Daten?</strong></p>
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei 
                kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder 
                bei der Registrierung angeben.
              </p>
              <p>
                Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme 
                erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem 
                oder Uhrzeit des Seitenaufrufs).
              </p>

              <p><strong>Wofür nutzen wir Ihre Daten?</strong></p>
              <p>
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website 
                zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet 
                werden, sofern Sie Ihre Einwilligung erteilt haben (Cookies).
              </p>

              <p><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong></p>
              <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und 
                Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem 
                ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine 
                Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung 
                jederzeit für die Zukunft widerrufen.
              </p>
            </section>

            <section>
              <h2>2. Hosting</h2>
              <p>
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              </p>
              
              <h3>Emergent / Cloud-Hosting</h3>
              <p>
                Unsere Website wird auf Cloud-Servern gehostet. Die dabei verarbeiteten 
                personenbezogenen Daten (IP-Adressen, technische Daten) werden auf den Servern 
                des Hosting-Anbieters gespeichert.
              </p>
              <p>
                Die Verwendung des Hostings erfolgt zum Zwecke der Vertragserfüllung gegenüber 
                unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im 
                Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres 
                Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
              </p>
            </section>

            <section>
              <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
              
              <h3>Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den 
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3>Hinweis zur verantwortlichen Stelle</h3>
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <p>
                <strong>StoryTales</strong><br />
                Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen<br />
                Deutschland
              </p>
              <p>
                E-Mail: info@storytales.xyz
              </p>
              <p>
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen 
                Daten (z.B. Namen, E-Mail-Adressen o.Ä.) entscheidet.
              </p>

              <h3>Speicherdauer</h3>
              <p>
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
                Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen 
                oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, 
                sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer 
                personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen).
              </p>

              <h3>Rechtsgrundlagen der Datenverarbeitung</h3>
              <p>
                Wir verarbeiten personenbezogene Daten nur, wenn eine der folgenden Rechtsgrundlagen 
                gegeben ist:
              </p>
              <ul>
                <li><strong>Art. 6 Abs. 1 lit. a DSGVO:</strong> Einwilligung des Betroffenen</li>
                <li><strong>Art. 6 Abs. 1 lit. b DSGVO:</strong> Vertragserfüllung oder vorvertragliche Maßnahmen</li>
                <li><strong>Art. 6 Abs. 1 lit. c DSGVO:</strong> Erfüllung einer rechtlichen Verpflichtung</li>
                <li><strong>Art. 6 Abs. 1 lit. f DSGVO:</strong> Berechtigtes Interesse</li>
              </ul>

              <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung 
                möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die 
                Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf 
                unberührt.
              </p>

              <h3>Recht auf Datenübertragbarkeit</h3>
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung 
                eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem 
                gängigen, maschinenlesbaren Format aushändigen zu lassen.
              </p>

              <h3>Auskunft, Löschung und Berichtigung</h3>
              <p>
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf 
                unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft 
                und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung 
                oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene 
                Daten können Sie sich jederzeit an uns wenden.
              </p>

              <h3>Recht auf Einschränkung der Verarbeitung</h3>
              <p>
                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten 
                zu verlangen. Hierzu können Sie sich jederzeit an uns wenden.
              </p>

              <h3>Widerspruch gegen Werbe-E-Mails</h3>
              <p>
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur 
                Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien 
                wird hiermit widersprochen.
              </p>
            </section>

            <section>
              <h2>4. Datenerfassung auf dieser Website</h2>

              <h3>Cookies</h3>
              <p>
                Unsere Website verwendet "Cookies". Cookies sind kleine Textdateien und richten auf 
                Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer 
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät 
                gespeichert.
              </p>
              <p>
                <strong>Verwendete Cookies:</strong>
              </p>
              <ul>
                <li><strong>Unbedingt notwendige Cookies:</strong> Authentifizierung, Sitzungsverwaltung, 
                Cookie-Einwilligungsstatus (Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO)</li>
                <li><strong>Funktionale Cookies:</strong> Spracheinstellungen (nur mit Ihrer Einwilligung 
                gemäß Art. 6 Abs. 1 lit. a DSGVO)</li>
              </ul>
              <p>
                Sie können Ihre Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und die 
                Annahme von Cookies ablehnen. Bitte beachten Sie, dass Sie in diesem Fall gegebenenfalls 
                nicht alle Funktionen dieser Website nutzen können.
              </p>
              <p>
                Weitere Informationen finden Sie in unserer Cookie-Richtlinie.
              </p>

              <h3>Server-Log-Dateien</h3>
              <p>
                Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten 
                Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt:
              </p>
              <ul>
                <li>Browsertyp und Browserversion</li>
                <li>Verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <p>
                Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Die Erfassung dieser 
                Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat 
                ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung 
                seiner Website.
              </p>

              <h3>Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung 
                vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die 
                Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an 
                uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
              </p>

              <h3>Registrierung auf dieser Website</h3>
              <p>
                Sie können sich auf unserer Website registrieren, um zusätzliche Funktionen zu nutzen. 
                Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen 
                Angebotes oder Dienstes. Bei der Registrierung werden folgende Daten erhoben:
              </p>
              <ul>
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Passwort (verschlüsselt gespeichert)</li>
                <li>Sprachpräferenz</li>
                <li>Optional: Kindle E-Mail-Adresse</li>
              </ul>
              <p>
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                Speicherdauer: Bis zur Löschung des Nutzerkontos
              </p>
            </section>

            <section>
              <h2>5. Datenverarbeitung bei Nutzung unseres Dienstes</h2>

              <h3>Erstellung von Kindergeschichten</h3>
              <p>
                Bei der Nutzung unseres Hauptdienstes – der Erstellung personalisierter Kindergeschichten 
                – verarbeiten wir folgende Daten:
              </p>
              <ul>
                <li><strong>Kinderdaten:</strong> Name des Kindes, Alter des Kindes</li>
                <li><strong>Geschichtenparameter:</strong> Gewähltes Thema, Spracheinstellung, optionale 
                benutzerdefinierte Themen</li>
                <li><strong>Pro-Nutzer zusätzlich:</strong> Haar- und Augenfarbe, optional hochgeladene Kinderfotos</li>
                <li><strong>Generierte Inhalte:</strong> KI-generierte Geschichtentexte und Illustrationen</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                <strong>Zweck:</strong> Bereitstellung des Dienstes, Erstellung personalisierter Geschichten<br />
                <strong>Speicherdauer:</strong> Bis zur Löschung durch den Nutzer oder Kontolöschung
              </p>

              <h3>Besonderer Hinweis: Verarbeitung von Kinderdaten</h3>
              <p className="privacy-highlight">
                <strong>⚠️ WICHTIG:</strong> Wir verarbeiten Daten über Kinder (Namen, Alter, Aussehen). 
                Gemäß Art. 8 DSGVO ist bei Kindern unter 16 Jahren die Einwilligung der Eltern erforderlich. 
                Als Nutzer bestätigen Sie:
              </p>
              <ul>
                <li>Dass Sie Elternteil oder Erziehungsberechtigter der genannten Kinder sind</li>
                <li>Dass Sie berechtigt sind, die Daten des Kindes anzugeben</li>
                <li>Dass Sie in die Verarbeitung der Kinderdaten einwilligen</li>
              </ul>
              <p>
                <strong>Elternrechte:</strong> Sie können jederzeit die Löschung aller Kinderdaten 
                verlangen. Nutzen Sie hierfür die Account-Löschfunktion oder kontaktieren Sie uns.
              </p>

              <h3>Hochgeladene Kinderfotos (Pro-Nutzer)</h3>
              <p>
                Pro-Nutzer können optional Fotos ihrer Kinder hochladen, um die Charakterbeschreibung 
                zu personalisieren. Diese Fotos werden:
              </p>
              <ul>
                <li>An die OpenAI GPT-4 Vision API übermittelt zur Bildanalyse</li>
                <li>Nicht dauerhaft gespeichert (nur temporär während der Verarbeitung)</li>
                <li>Nur zur Extraktion von Erscheinungsmerkmalen verwendet (Haarfarbe, Augenfarbe, etc.)</li>
                <li>Nicht in den generierten Geschichten eingebettet</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und 
                Art. 8 DSGVO (Elterneinwilligung)<br />
                <strong>Drittanbieter:</strong> OpenAI (siehe Abschnitt "Datenübermittlung in Drittländer")<br />
                <strong>Speicherdauer:</strong> Temporär, nicht dauerhaft gespeichert
              </p>
            </section>

            <section>
              <h2>6. Zahlungsdienstleister</h2>

              <h3>Stripe</h3>
              <p>
                Wir bieten die Möglichkeit der Zahlung mittels Stripe an. Anbieter ist Stripe, Inc., 
                510 Townsend Street, San Francisco, CA 94103, USA (nachfolgend "Stripe").
              </p>
              <p>
                Bei Zahlung über Stripe werden Ihre Zahlungsdaten (Kreditkartennummer, Name, Adresse) 
                an Stripe übermittelt. Die Übermittlung Ihrer Daten an Stripe erfolgt auf Grundlage 
                von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. f DSGVO 
                (berechtigtes Interesse an einem sicheren Zahlungsverkehr).
              </p>
              <p>
                <strong>Datenübermittlung in die USA:</strong> Stripe ist nach dem EU-US Data Privacy 
                Framework zertifiziert. Details: 
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/privacy
                </a>
              </p>

              <h3>PayPal</h3>
              <p>
                Wir bieten die Möglichkeit der Zahlung mittels PayPal an. Anbieter ist PayPal (Europe) 
                S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (nachfolgend "PayPal").
              </p>
              <p>
                Bei Zahlung über PayPal werden Ihre Zahlungsdaten an PayPal übermittelt. Die Übermittlung 
                erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 
                lit. f DSGVO (berechtigtes Interesse).
              </p>
              <p>
                Details: 
                <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener noreferrer">
                  https://www.paypal.com/de/webapps/mpp/ua/privacy-full
                </a>
              </p>
            </section>

            <section>
              <h2>7. KI-Dienste und Datenübermittlung in Drittländer</h2>

              <h3>Google Gemini 2.5 Pro (Textgenerierung)</h3>
              <p>
                Zur Generierung der Geschichtentexte nutzen wir den KI-Dienst "Gemini 2.5 Pro" von 
                Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
              </p>
              <p>
                <strong>Übermittelte Daten:</strong>
              </p>
              <ul>
                <li>Kindername (vom Nutzer eingegeben)</li>
                <li>Alter des Kindes</li>
                <li>Gewähltes Geschichtenthema oder benutzerdefiniertes Thema</li>
                <li>Spracheinstellung</li>
                <li>Charakterbeschreibung (bei Pro-Nutzern)</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                <strong>Datenübermittlung in die USA:</strong> Google ist nach dem EU-US Data Privacy 
                Framework zertifiziert.<br />
                <strong>Speicherung durch Google:</strong> Gemäß Google-Datenschutzrichtlinie werden 
                API-Anfragen nicht zur Verbesserung der Dienste verwendet.<br />
                Details: 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </p>

              <h3>KI-Bildgenerierung (DALL-E und Nano Banana)</h3>
              <p>
                Zur Generierung der Illustrationen nutzen wir KI-Dienste: "DALL-E 2" und "DALL-E 3" 
                von OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA sowie "Nano Banana" (Gemini Image Generation) von Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
              </p>
              <p>
                <strong>Übermittelte Daten:</strong>
              </p>
              <ul>
                <li>Bildbeschreibungen basierend auf der generierten Geschichte</li>
                <li>Charakterbeschreibung</li>
                <li>Stilangaben</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                <strong>Datenübermittlung in die USA:</strong> OpenAI hat EU-Standardvertragsklauseln 
                implementiert.<br />
                Details: 
                <a href="https://openai.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://openai.com/privacy
                </a>
              </p>

              <h3>OpenAI GPT-4 Vision (Bildanalyse für Pro-Nutzer)</h3>
              <p>
                Pro-Nutzer können optional Kinderfotos hochladen. Diese werden durch OpenAI GPT-4 Vision 
                analysiert, um Erscheinungsmerkmale (Haarfarbe, Augenfarbe, etc.) zu extrahieren.
              </p>
              <p>
                <strong>Übermittelte Daten:</strong> Hochgeladene Kinderfotos (temporär)<br />
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) + 
                Art. 8 DSGVO (Elterneinwilligung)<br />
                <strong>Speicherung:</strong> Keine dauerhafte Speicherung, nur temporäre Verarbeitung<br />
                <strong>Löschung:</strong> Fotos werden nach der Analyse sofort gelöscht
              </p>

              <h3>Cloudinary (Bildspeicherung)</h3>
              <p>
                Generierte Illustrationen werden auf Cloudinary (Cloudinary Ltd., UK) gespeichert, 
                um die Performance zu optimieren.
              </p>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse 
                an effizienter Bereitstellung)<br />
                <strong>Speicherdauer:</strong> Bis zur Löschung der Geschichte durch den Nutzer
              </p>
            </section>

            <section>
              <h2>8. Social Media und Single Sign-On</h2>

              <h3>Google OAuth (Social Login)</h3>
              <p>
                Wir bieten die Möglichkeit der Registrierung und Anmeldung über Ihren Google-Account an 
                ("Google Sign-In"). Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, 
                Dublin 4, Irland.
              </p>
              <p>
                Bei der Anmeldung über Google werden folgende Daten übermittelt:
              </p>
              <ul>
                <li>E-Mail-Adresse</li>
                <li>Name</li>
                <li>Google-Nutzer-ID</li>
                <li>Profilbild (optional)</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und 
                Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                Details: 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2>9. E-Mail-Versand</h2>

              <h3>Kindle E-Mail-Versand (Send to Kindle)</h3>
              <p>
                Pro-Nutzer können Geschichten an ihre Kindle-E-Mail-Adresse senden lassen. Hierfür nutzen 
                wir einen SMTP-Dienst.
              </p>
              <p>
                <strong>Übermittelte Daten:</strong>
              </p>
              <ul>
                <li>Kindle E-Mail-Adresse (vom Nutzer angegeben)</li>
                <li>Name des Nutzers</li>
                <li>Generierte Geschichte als PDF-Anhang</li>
              </ul>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)<br />
                <strong>Speicherung:</strong> E-Mails werden nicht dauerhaft gespeichert
              </p>
            </section>

            <section>
              <h2>10. Ihre Rechte als betroffene Person</h2>

              <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>

              <h3>Recht auf Auskunft (Art. 15 DSGVO)</h3>
              <p>
                Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob Sie betreffende 
                personenbezogene Daten verarbeitet werden und Auskunft über diese Daten sowie weitere 
                Informationen zu erhalten.
              </p>

              <h3>Recht auf Berichtigung (Art. 16 DSGVO)</h3>
              <p>
                Sie haben das Recht, die unverzügliche Berichtigung Sie betreffender unrichtiger 
                personenbezogener Daten zu verlangen.
              </p>

              <h3>Recht auf Löschung (Art. 17 DSGVO)</h3>
              <p>
                Sie haben das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten 
                unverzüglich gelöscht werden. Dies können Sie jederzeit über die Account-Löschfunktion 
                in den Einstellungen durchführen oder uns per E-Mail kontaktieren.
              </p>

              <h3>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</h3>
              <p>
                Sie haben das Recht, von uns die Einschränkung der Verarbeitung zu verlangen.
              </p>

              <h3>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h3>
              <p>
                Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, 
                gängigen und maschinenlesbaren Format zu erhalten.
              </p>

              <h3>Widerspruchsrecht (Art. 21 DSGVO)</h3>
              <p>
                Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, 
                jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten Widerspruch 
                einzulegen.
              </p>

              <h3>Beschwerderecht bei der Aufsichtsbehörde (Art. 77 DSGVO)</h3>
              <p>
                Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über unsere Verarbeitung 
                personenbezogener Daten zu beschweren.
              </p>
              <p>
                <strong>Zuständige Aufsichtsbehörde in Deutschland:</strong><br />
                Der Landesbeauftragte für Datenschutz und Informationsfreiheit Rheinland-Pfalz<br />
                Hintere Bleiche 34<br />
                55116 Mainz<br />
                Website: 
                <a href="https://www.datenschutz.rlp.de" target="_blank" rel="noopener noreferrer">
                  www.datenschutz.rlp.de
                </a>
              </p>
            </section>

            <section>
              <h2>11. Datensicherheit</h2>
              <p>
                Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre 
                Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen 
                den Zugriff unberechtigter Personen zu schützen:
              </p>
              <ul>
                <li>SSL/TLS-Verschlüsselung für alle Datenübertragungen</li>
                <li>Verschlüsselte Speicherung von Passwörtern (Hashing)</li>
                <li>Regelmäßige Sicherheitsupdates</li>
                <li>Zugriffsbeschränkungen auf personenbezogene Daten</li>
                <li>Sichere Cloud-Infrastruktur</li>
              </ul>
            </section>

            <section>
              <h2>12. Datenlöschung und Speicherdauer</h2>
              <p>
                Wir löschen Ihre personenbezogenen Daten, sobald sie für die Zwecke, für die wir sie 
                erhoben haben, nicht mehr erforderlich sind:
              </p>
              <ul>
                <li><strong>Account-Daten:</strong> Bei Kontolöschung werden alle personenbezogenen Daten 
                gelöscht (außer gesetzlich vorgeschriebene Aufbewahrungspflichten)</li>
                <li><strong>Geschichten:</strong> Werden bei Kontolöschung gelöscht oder können individuell 
                gelöscht werden</li>
                <li><strong>Zahlungsdaten:</strong> Aufbewahrung gemäß steuerrechtlicher Vorgaben 
                (10 Jahre in Deutschland)</li>
                <li><strong>Log-Dateien:</strong> Werden nach 30 Tagen gelöscht</li>
              </ul>
            </section>

            <section>
              <h2>13. Änderungen dieser Datenschutzerklärung</h2>
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets 
                den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen 
                in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue 
                Datenschutzerklärung.
              </p>
            </section>

            <section className="contact-section">
              <h2>14. Kontakt in Datenschutzangelegenheiten</h2>
              <p>
                Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte können Sie uns kontaktieren:
              </p>
              <p>
                <strong>E-Mail:</strong> info@storytales.xyz<br />
                <strong>Postanschrift:</strong><br />
                StoryTales - Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen<br />
                Deutschland
              </p>
            </section>
          </>
        ) : (
          <>
            {/* ENGLISH VERSION */}
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US')}</p>

            <section>
              <h2>1. Privacy at a Glance</h2>
              
              <h3>General Information</h3>
              <p>
                The following notes provide a simple overview of what happens to your personal data when 
                you visit our website and use our service. Personal data is any data that can be used to 
                identify you personally.
              </p>

              <h3>Data Collection on Our Website</h3>
              <p><strong>Who is responsible for data collection on this website?</strong></p>
              <p>
                Data processing on this website is carried out by the website operator. You can find 
                their contact details in the legal notice of this website.
              </p>

              <p><strong>How do we collect your data?</strong></p>
              <p>
                Your data is collected when you provide it to us. This may include data you enter in 
                a contact form or during registration.
              </p>
              <p>
                Other data is collected automatically by our IT systems when you visit the website. 
                This is mainly technical data (e.g. internet browser, operating system, or time of page view).
              </p>

              <p><strong>What do we use your data for?</strong></p>
              <p>
                Some data is collected to ensure error-free provision of the website. Other data may 
                be used to analyze your user behavior if you have given your consent (cookies).
              </p>

              <p><strong>What rights do you have regarding your data?</strong></p>
              <p>
                You always have the right to request information free of charge about the origin, 
                recipients, and purpose of your stored personal data. You also have the right to 
                request correction or deletion of this data. If you have given consent to data 
                processing, you can revoke this consent at any time for the future.
              </p>
            </section>

            <section>
              <h2>2. Hosting</h2>
              <p>
                We host the content of our website with the following provider:
              </p>
              
              <h3>Emergent / Cloud Hosting</h3>
              <p>
                Our website is hosted on cloud servers. Personal data processed in this context 
                (IP addresses, technical data) is stored on the hosting provider's servers.
              </p>
              <p>
                The use of hosting is for the purpose of fulfilling contracts with our potential and 
                existing customers (Art. 6 (1) lit. b GDPR) and in the interest of secure, fast, and 
                efficient provision of our online offering by a professional provider (Art. 6 (1) lit. f GDPR).
              </p>
            </section>

            <section>
              <h2>3. General Information and Mandatory Information</h2>
              
              <h3>Data Protection</h3>
              <p>
                The operators of these pages take the protection of your personal data very seriously. 
                We treat your personal data confidentially and in accordance with statutory data 
                protection regulations and this privacy policy.
              </p>

              <h3>Note on the Responsible Party</h3>
              <p>The responsible party for data processing on this website is:</p>
              <p>
                <strong>StoryTales</strong><br />
                Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen<br />
                Germany
              </p>
              <p>
                Email: info@storytales.xyz
              </p>

              <h3>Storage Duration</h3>
              <p>
                Unless a more specific storage period is stated in this privacy policy, your personal 
                data will remain with us until the purpose for data processing no longer applies.
              </p>

              <h3>Legal Basis for Data Processing</h3>
              <p>
                We process personal data only if one of the following legal bases exists:
              </p>
              <ul>
                <li><strong>Art. 6 (1) lit. a GDPR:</strong> Consent of the data subject</li>
                <li><strong>Art. 6 (1) lit. b GDPR:</strong> Contract fulfillment or pre-contractual measures</li>
                <li><strong>Art. 6 (1) lit. c GDPR:</strong> Legal obligation</li>
                <li><strong>Art. 6 (1) lit. f GDPR:</strong> Legitimate interest</li>
              </ul>

              <h3>Revocation of Your Consent to Data Processing</h3>
              <p>
                Many data processing operations are only possible with your express consent. You can 
                revoke consent you have already given at any time. The lawfulness of data processing 
                carried out until the revocation remains unaffected by the revocation.
              </p>

              <h3>Right to Data Portability</h3>
              <p>
                You have the right to have data that we process automatically on the basis of your 
                consent or in fulfillment of a contract handed over to you or to a third party in a 
                common, machine-readable format.
              </p>

              <h3>Information, Deletion, and Correction</h3>
              <p>
                Within the framework of the applicable legal provisions, you have the right to free 
                information about your stored personal data, its origin and recipients, and the purpose 
                of data processing and, if applicable, a right to correction or deletion of this data.
              </p>

              <h3>Right to Restriction of Processing</h3>
              <p>
                You have the right to request restriction of the processing of your personal data.
              </p>

              <h3>Objection to Advertising Emails</h3>
              <p>
                We hereby object to the use of contact data published within the framework of the 
                imprint obligation to send unsolicited advertising and information materials.
              </p>
            </section>

            <section>
              <h2>4. Data Collection on This Website</h2>

              <h3>Cookies</h3>
              <p>
                Our website uses "cookies". Cookies are small text files and do not cause any damage 
                to your device. They are stored either temporarily for the duration of a session 
                (session cookies) or permanently (permanent cookies) on your device.
              </p>
              <p>
                <strong>Cookies Used:</strong>
              </p>
              <ul>
                <li><strong>Strictly Necessary Cookies:</strong> Authentication, session management, 
                cookie consent status (Legal basis: Art. 6 (1) lit. f GDPR)</li>
                <li><strong>Functional Cookies:</strong> Language preferences (only with your consent 
                according to Art. 6 (1) lit. a GDPR)</li>
              </ul>
              <p>
                You can configure your browser settings according to your wishes and refuse cookies. 
                Please note that you may not be able to use all functions of this website in this case.
              </p>
              <p>
                For more information, see our Cookie Policy.
              </p>

              <h3>Server Log Files</h3>
              <p>
                The page provider automatically collects and stores information in server log files 
                that your browser automatically transmits to us:
              </p>
              <ul>
                <li>Browser type and version</li>
                <li>Operating system used</li>
                <li>Referrer URL</li>
                <li>Hostname of the accessing computer</li>
                <li>Time of server request</li>
                <li>IP address</li>
              </ul>
              <p>
                This data is not merged with other data sources. Data collection is based on 
                Art. 6 (1) lit. f GDPR. The website operator has a legitimate interest in the 
                technically error-free presentation and optimization of their website.
              </p>

              <h3>Contact Form</h3>
              <p>
                If you send us inquiries via the contact form, your information from the inquiry form, 
                including the contact data you provided there, will be stored by us for the purpose of 
                processing the inquiry and in case of follow-up questions.
              </p>
              <p>
                Processing of this data is based on Art. 6 (1) lit. b GDPR if your inquiry is related 
                to the fulfillment of a contract or is necessary for pre-contractual measures. In all 
                other cases, processing is based on our legitimate interest in effectively processing 
                inquiries addressed to us (Art. 6 (1) lit. f GDPR).
              </p>

              <h3>Registration on This Website</h3>
              <p>
                You can register on our website to use additional functions. The data entered for this 
                purpose is used only for the purpose of using the respective offer or service. The 
                following data is collected during registration:
              </p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Password (stored encrypted)</li>
                <li>Language preference</li>
                <li>Optional: Kindle email address</li>
              </ul>
              <p>
                Legal basis: Art. 6 (1) lit. b GDPR (contract fulfillment)<br />
                Storage duration: Until deletion of user account
              </p>
            </section>

            <section>
              <h2>5. Data Processing When Using Our Service</h2>

              <h3>Creation of Children's Stories</h3>
              <p>
                When using our main service – creating personalized children's stories – we process 
                the following data:
              </p>
              <ul>
                <li><strong>Child data:</strong> Child's name, child's age</li>
                <li><strong>Story parameters:</strong> Selected theme, language setting, optional 
                custom themes</li>
                <li><strong>Pro users additionally:</strong> Hair and eye color, optionally uploaded 
                child photos</li>
                <li><strong>Generated content:</strong> AI-generated story texts and illustrations</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. b GDPR (contract fulfillment)<br />
                <strong>Purpose:</strong> Provision of service, creation of personalized stories<br />
                <strong>Storage duration:</strong> Until deletion by user or account deletion
              </p>

              <h3>Special Note: Processing of Children's Data</h3>
              <p className="privacy-highlight">
                <strong>⚠️ IMPORTANT:</strong> We process data about children (names, age, appearance). 
                According to Art. 8 GDPR, parental consent is required for children under 16. As a user, 
                you confirm:
              </p>
              <ul>
                <li>That you are the parent or legal guardian of the named children</li>
                <li>That you are authorized to provide the child's data</li>
                <li>That you consent to the processing of the child's data</li>
              </ul>
              <p>
                <strong>Parental rights:</strong> You can request deletion of all child data at any time. 
                Use the account deletion function or contact us.
              </p>

              <h3>Uploaded Child Photos (Pro Users)</h3>
              <p>
                Pro users can optionally upload photos of their children to personalize the character 
                description. These photos:
              </p>
              <ul>
                <li>Are transmitted to the OpenAI GPT-4 Vision API for image analysis</li>
                <li>Are not permanently stored (only temporarily during processing)</li>
                <li>Are only used to extract appearance features (hair color, eye color, etc.)</li>
                <li>Are not embedded in the generated stories</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. a GDPR (consent) and Art. 8 GDPR 
                (parental consent)<br />
                <strong>Third-party provider:</strong> OpenAI (see section "Data Transfer to Third Countries")<br />
                <strong>Storage duration:</strong> Temporary, not permanently stored
              </p>
            </section>

            <section>
              <h2>6. Payment Service Providers</h2>

              <h3>Stripe</h3>
              <p>
                We offer payment via Stripe. Provider is Stripe, Inc., 510 Townsend Street, 
                San Francisco, CA 94103, USA (hereinafter "Stripe").
              </p>
              <p>
                When paying via Stripe, your payment data (credit card number, name, address) is 
                transmitted to Stripe. Transmission of your data to Stripe is based on Art. 6 (1) 
                lit. b GDPR (contract fulfillment) and Art. 6 (1) lit. f GDPR (legitimate interest 
                in secure payment processing).
              </p>
              <p>
                <strong>Data transfer to USA:</strong> Stripe is certified under the EU-US Data Privacy 
                Framework. Details: 
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/privacy
                </a>
              </p>

              <h3>PayPal</h3>
              <p>
                We offer payment via PayPal. Provider is PayPal (Europe) S.à r.l. et Cie, S.C.A., 
                22-24 Boulevard Royal, L-2449 Luxembourg (hereinafter "PayPal").
              </p>
              <p>
                When paying via PayPal, your payment data is transmitted to PayPal. Transmission is 
                based on Art. 6 (1) lit. b GDPR (contract fulfillment) and Art. 6 (1) lit. f GDPR 
                (legitimate interest).
              </p>
              <p>
                Details: 
                <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener noreferrer">
                  https://www.paypal.com/webapps/mpp/ua/privacy-full
                </a>
              </p>
            </section>

            <section>
              <h2>7. AI Services and Data Transfer to Third Countries</h2>

              <h3>Google Gemini 2.5 Pro (Text Generation)</h3>
              <p>
                To generate story texts, we use the AI service "Gemini 2.5 Pro" from Google LLC, 
                1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
              </p>
              <p>
                <strong>Transmitted data:</strong>
              </p>
              <ul>
                <li>Child's name (entered by user)</li>
                <li>Child's age</li>
                <li>Selected story theme or custom theme</li>
                <li>Language setting</li>
                <li>Character description (for Pro users)</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. b GDPR (contract fulfillment)<br />
                <strong>Data transfer to USA:</strong> Google is certified under the EU-US Data Privacy 
                Framework.<br />
                <strong>Storage by Google:</strong> According to Google's privacy policy, API requests 
                are not used to improve services.<br />
                Details: 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </p>

              <h3>AI Image Generation (DALL-E and Nano Banana)</h3>
              <p>
                To generate illustrations, we use AI services: "DALL-E 2" and "DALL-E 3" from 
                OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA and "Nano Banana" (Gemini Image Generation) from Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
              </p>
              <p>
                <strong>Transmitted data:</strong>
              </p>
              <ul>
                <li>Image descriptions based on the generated story</li>
                <li>Character description</li>
                <li>Style specifications</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. b GDPR (contract fulfillment)<br />
                <strong>Data transfer to USA:</strong> OpenAI has implemented EU Standard Contractual Clauses.<br />
                Details: 
                <a href="https://openai.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://openai.com/privacy
                </a>
              </p>

              <h3>OpenAI GPT-4 Vision (Image Analysis for Pro Users)</h3>
              <p>
                Pro users can optionally upload child photos. These are analyzed by OpenAI GPT-4 Vision 
                to extract appearance features (hair color, eye color, etc.).
              </p>
              <p>
                <strong>Transmitted data:</strong> Uploaded child photos (temporary)<br />
                <strong>Legal basis:</strong> Art. 6 (1) lit. a GDPR (consent) + Art. 8 GDPR 
                (parental consent)<br />
                <strong>Storage:</strong> No permanent storage, only temporary processing<br />
                <strong>Deletion:</strong> Photos are deleted immediately after analysis
              </p>

              <h3>Cloudinary (Image Storage)</h3>
              <p>
                Generated illustrations are stored on Cloudinary (Cloudinary Ltd., UK) to optimize performance.
              </p>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. f GDPR (legitimate interest in efficient delivery)<br />
                <strong>Storage duration:</strong> Until deletion of story by user
              </p>
            </section>

            <section>
              <h2>8. Social Media and Single Sign-On</h2>

              <h3>Google OAuth (Social Login)</h3>
              <p>
                We offer the option to register and log in via your Google account ("Google Sign-In"). 
                Provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.
              </p>
              <p>
                When logging in via Google, the following data is transmitted:
              </p>
              <ul>
                <li>Email address</li>
                <li>Name</li>
                <li>Google user ID</li>
                <li>Profile picture (optional)</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. a GDPR (consent) and Art. 6 (1) lit. b GDPR 
                (contract fulfillment)<br />
                Details: 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2>9. Email Delivery</h2>

              <h3>Kindle Email Delivery (Send to Kindle)</h3>
              <p>
                Pro users can have stories sent to their Kindle email address. For this, we use an SMTP service.
              </p>
              <p>
                <strong>Transmitted data:</strong>
              </p>
              <ul>
                <li>Kindle email address (provided by user)</li>
                <li>User's name</li>
                <li>Generated story as PDF attachment</li>
              </ul>
              <p>
                <strong>Legal basis:</strong> Art. 6 (1) lit. b GDPR (contract fulfillment)<br />
                <strong>Storage:</strong> Emails are not permanently stored
              </p>
            </section>

            <section>
              <h2>10. Your Rights as a Data Subject</h2>

              <p>You have the following rights regarding your personal data:</p>

              <h3>Right to Access (Art. 15 GDPR)</h3>
              <p>
                You have the right to request confirmation from us as to whether personal data concerning 
                you is being processed and to receive information about this data.
              </p>

              <h3>Right to Rectification (Art. 16 GDPR)</h3>
              <p>
                You have the right to request the immediate correction of inaccurate personal data 
                concerning you.
              </p>

              <h3>Right to Erasure (Art. 17 GDPR)</h3>
              <p>
                You have the right to request that we delete personal data concerning you without undue 
                delay. You can do this at any time via the account deletion function in the settings or 
                contact us by email.
              </p>

              <h3>Right to Restriction of Processing (Art. 18 GDPR)</h3>
              <p>
                You have the right to request restriction of processing from us.
              </p>

              <h3>Right to Data Portability (Art. 20 GDPR)</h3>
              <p>
                You have the right to receive personal data concerning you in a structured, commonly used, 
                and machine-readable format.
              </p>

              <h3>Right to Object (Art. 21 GDPR)</h3>
              <p>
                You have the right to object at any time, on grounds relating to your particular situation, 
                to the processing of personal data concerning you.
              </p>

              <h3>Right to Lodge a Complaint with a Supervisory Authority (Art. 77 GDPR)</h3>
              <p>
                You have the right to lodge a complaint with a data protection supervisory authority about 
                our processing of personal data.
              </p>
              <p>
                <strong>Competent supervisory authority in Germany:</strong><br />
                The State Commissioner for Data Protection and Freedom of Information Rhineland-Palatinate<br />
                Hintere Bleiche 34<br />
                55116 Mainz<br />
                Website: 
                <a href="https://www.datenschutz.rlp.de" target="_blank" rel="noopener noreferrer">
                  www.datenschutz.rlp.de
                </a>
              </p>
            </section>

            <section>
              <h2>11. Data Security</h2>
              <p>
                We use appropriate technical and organizational security measures to protect your data 
                against accidental or intentional manipulation, loss, destruction, or access by unauthorized persons:
              </p>
              <ul>
                <li>SSL/TLS encryption for all data transfers</li>
                <li>Encrypted storage of passwords (hashing)</li>
                <li>Regular security updates</li>
                <li>Access restrictions to personal data</li>
                <li>Secure cloud infrastructure</li>
              </ul>
            </section>

            <section>
              <h2>12. Data Deletion and Storage Duration</h2>
              <p>
                We delete your personal data as soon as it is no longer required for the purposes for 
                which we collected it:
              </p>
              <ul>
                <li><strong>Account data:</strong> Deleted upon account deletion (except legally required 
                retention obligations)</li>
                <li><strong>Stories:</strong> Deleted upon account deletion or can be deleted individually</li>
                <li><strong>Payment data:</strong> Retained according to tax law requirements (10 years in Germany)</li>
                <li><strong>Log files:</strong> Deleted after 30 days</li>
              </ul>
            </section>

            <section>
              <h2>13. Changes to This Privacy Policy</h2>
              <p>
                We reserve the right to occasionally adjust this privacy policy so that it always complies 
                with current legal requirements or to implement changes to our services in the privacy policy. 
                The new privacy policy will then apply to your next visit.
              </p>
            </section>

            <section className="contact-section">
              <h2>14. Contact for Data Protection Matters</h2>
              <p>
                For questions about data protection or to exercise your rights, you can contact us:
              </p>
              <p>
                <strong>Email:</strong> info@storytales.xyz<br />
                <strong>Postal address:</strong><br />
                StoryTales - Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen<br />
                Germany
              </p>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
